export const dashboardTranslations = {
  en: {
    loading: "Loading...",
    most_viewed: "Most Viewed",
    oldest_first: "Oldest First",
    newest_first: "Newest First",
    scroll_left: "Scroll left",
    scroll_right: "Scroll right",
    sort: "Sort",
    most_view: "Most View",
    no_cards_available: "No cards available",
    no_cards_description: "There are currently no cards available to show.",
    no_user_logged_in: "No user logged in.",
    error_loading_profile: "Error loading profile.",
    failed_to_load_profile_view_stats: "Failed to load profile view stats.",
    failed_to_load_card_view_stats: "Failed to load card view stats.",
    failed_to_load_dashboard_data: "Failed to load dashboard data.",
    manager_request: "Manager Request",
    manager_request_content: "wants to add himself as a manager to you",
    accept: "Accept",
    decline: "Decline",
    total_profile_views: "Total Profile Views",
    seven_days: "7 Days",
    one_month: "1 Month",
    all: "All",
    profile_views_by_country: "Profile Views by Country",
    card_views_by_country: "Card Views by Country",
    views: "views",
    countries: "Countries",
    not_specified: "Not specified",
    no_chart_data: "No Chart Data",
    no_chart_data_description: "No chart data description",
    select_item_for_chart: "Select item for Chart",
    click_profile_or_card_to_view_analytics: "Click Profile or Card to view analytics",
    accepted: "Request Accepted successfully",
    declined: "Request Declined successfully",
    description: "Post Description",
    title: "Title",
    startPost: "What’s on your mind?",
    post: "Post",
    photo: "Photo",
    video: "Video",
    posting: "Posting...",
    empty: "Please add a title, text, or media before posting.",
    title_required: "Please enter a title before posting.",
    success: "Post created successfully!",
    error: "Something went wrong.",

    deal_id: "Deal ID",
    deal_type: "Deal Type",
    status: "Status",
    price: "Price",
    currency: "Currency",
    sport: "Sport",
    location: "Location",
    event_date: "Event Date",
    received_amount: "Received Amount",
    paid_at: "Paid At",
    no_closed_deal_payments: "No closed deal payments available.",
    go_to_deals: "Go To Deals",
    active_deal: "Active Deal",
    closed_deal: "Closed Deal",
    loading_active_deals: "Loading active deals...",
    no_active_deals: "No active deals available.",
    created_at: "Created At",
    fighter: "Fighter",
    manager: "Manager",
    refund: "Refund",
    deal_types: {
      FIGHT_SINGLE: "Fight Single",
      FIGHT_TOURNAMENT: "Fight Tournament",
      SPARRING: "Sparring",
    },
    deal_status: {
      PROPOSED: "Proposed",
      ACCEPTED: "Accepted",
      CONFIRMED: "Confirmed",
      WAITING_FOR_RESULT: "Waiting for result",
      RESULT_UPDATED: "Result updated",
      RESULT_CONFIRMED: "Result confirmed",
      FIGHTER_RATED: "Fighter rated",
      MANAGER_RATED: "Manager rated",
      FINISHED: "Finished",
      CANCELLED: "Cancelled",
      REJECTED: "Rejected",
      DISPUTE: "Dispute",
    },
    total_income: "Total Income",
    total_refund: "Total Refund",
    total_expense: "Total Expense",
    total_deals: "Total Deals",
    expense_amount: "Expense Amount",
    income: "Income",
    no_payments: "No closed deal payments available."
  },

  de: {
    loading: "Laden...",
    most_viewed: "Am meisten angesehen",
    oldest_first: "Älteste zuerst",
    newest_first: "Neueste zuerst",
    scroll_left: "Nach links scrollen",
    scroll_right: "Nach rechts scrollen",
    sort: "Sortieren",
    most_view: "Meist angesehen",
    no_cards_available: "Keine Karten verfügbar",
    no_cards_description: "Derzeit sind keine Karten zur Anzeige verfügbar.",
    no_user_logged_in: "Kein Benutzer angemeldet.",
    error_loading_profile: "Fehler beim Laden des Profils.",
    failed_to_load_profile_view_stats: "Fehler beim Laden der Profilansichtsstatistiken.",
    failed_to_load_card_view_stats: "Fehler beim Laden der Kartenansichtsstatistiken.",
    failed_to_load_dashboard_data: "Fehler beim Laden der Dashboard-Daten.",
    manager_request: "Manager-Anfrage",
    manager_request_content: "möchte sich selbst als Manager zu Ihnen hinzufügen",
    accept: "Akzeptieren",
    decline: "Ablehnen",
    total_profile_views: "Gesamtprofilansichten",
    seven_days: "7 Tage",
    one_month: "1 Monat",
    all: "Alle",
    profile_views_by_country: "Profilansichten nach Land",
    card_views_by_country: "Kartenansichten nach Land",
    views: "Ansichten",
    countries: "Länder",
    not_specified: "Nicht angegeben",
    no_chart_data: "Keine Diagrammdaten",
    no_chart_data_description: "Keine Diagrammbeschreibung verfügbar",
    select_item_for_chart: "Element für Diagramm auswählen",
    click_profile_or_card_to_view_analytics: "Klicken Sie auf Profil oder Karte, um Analysen anzuzeigen",
    accepted: "Anfrage erfolgreich akzeptiert",
    declined: "Anfrage erfolgreich abgelehnt",
    description: "Beitragsbeschreibung",
    title: "Titel",
    startPost: "Was geht dir durch den Kopf?",
    post: "Posten",
    photo: "Foto",
    video: "Video",
    posting: "Posten...",
    empty: "Bitte fügen Sie einen Titel, Text oder Medien hinzu, bevor Sie posten.",
    title_required: "Bitte geben Sie vor dem Posten einen Titel ein.",
    success: "Post erfolgreich erstellt!",
    error: "Etwas ist schiefgelaufen.",

    deal_id: "Deal-ID",
    deal_type: "Deal-Typ",
    status: "Status",
    price: "Preis",
    currency: "Währung",
    sport: "Sport",
    location: "Ort",
    event_date: "Veranstaltungsdatum",
    received_amount: "Eingegangener Betrag",
    paid_at: "Bezahlt am",
    no_closed_deal_payments: "Keine abgeschlossenen Deal-Zahlungen verfügbar.",
    go_to_deals: "Zu den Deals",
    active_deal: "Aktiver Deal",
    closed_deal: "Abgeschlossener Deal",
    loading_active_deals: "Aktive Deals werden geladen...",
    no_active_deals: "Keine aktiven Deals verfügbar.",
    created_at: "Erstellt am",
    fighter: "Kämpfer",
    manager: "Manager",
    refund: "Rückerstattung",
    deal_types: {
      FIGHT_SINGLE: "Einzelkampf",
      FIGHT_TOURNAMENT: "Kampfturnier",
      SPARRING: "Sparring",
    },
    deal_status: {
      PROPOSED: "Vorgeschlagen",
      ACCEPTED: "Akzeptiert",
      CONFIRMED: "Bestätigt",
      WAITING_FOR_RESULT: "Wartet auf Ergebnis",
      RESULT_UPDATED: "Ergebnis aktualisiert",
      RESULT_CONFIRMED: "Ergebnis bestätigt",
      FIGHTER_RATED: "Kämpfer bewertet",
      MANAGER_RATED: "Manager bewertet",
      FINISHED: "Abgeschlossen",
      CANCELLED: "Storniert",
      REJECTED: "Abgelehnt",
      DISPUTE: "Streitfall",
    },
    total_income: "Gesamteinnahmen",
    total_refund: "Gesamtrückerstattung",
    total_expense: "Gesamtausgaben",
    total_deals: "Gesamtanzahl Deals",
    expense_amount: "Ausgabenbetrag",
    income: "Einnahmen",
    no_payments: "Keine abgeschlossenen Deal-Zahlungen verfügbar."
  },

  hr: {
    loading: "Učitavanje...",
    most_viewed: "Najviše pregledano",
    oldest_first: "Najstarije prvo",
    newest_first: "Najnovije prvo",
    scroll_left: "Pomakni lijevo",
    scroll_right: "Pomakni desno",
    sort: "Sortiraj",
    most_view: "Najgledanije",
    no_cards_available: "Nema dostupnih kartica",
    no_cards_description: "Trenutno nema dostupnih kartica za prikaz.",
    no_user_logged_in: "Nema prijavljenog korisnika.",
    error_loading_profile: "Pogreška pri učitavanju profila.",
    failed_to_load_profile_view_stats: "Neuspješno učitavanje statistika pregleda profila.",
    failed_to_load_card_view_stats: "Neuspješno učitavanje statistika pregleda kartica.",
    failed_to_load_dashboard_data: "Neuspješno učitavanje podataka nadzorne ploče.",
    manager_request: "Zahtjev menadžera",
    manager_request_content: "želi se dodati kao menadžer kod vas",
    accept: "Prihvati",
    decline: "Odbij",
    total_profile_views: "Ukupni pregledi profila",
    seven_days: "7 dana",
    one_month: "1 mjesec",
    all: "Svi",
    profile_views_by_country: "Pregledi profila po zemljama",
    card_views_by_country: "Pregledi kartica po zemljama",
    views: "pregledi",
    countries: "Zemlje",
    not_specified: "Nije navedeno",
    no_chart_data: "Nema podataka za grafikon",
    no_chart_data_description: "Nema opisa podataka za grafikon",
    select_item_for_chart: "Odaberite stavku za grafikon",
    click_profile_or_card_to_view_analytics: "Kliknite na profil ili karticu za prikaz analitike",
    accepted: "Zahtjev je uspješno prihvaćen",
    declined: "Zahtjev je uspješno odbijen",
    description: "Opis objave",
    title: "Naslov",
    startPost: "Što ti je na umu?",
    post: "Objavi",
    photo: "Fotografija",
    video: "Video",
    posting: "Objavljivanje...",
    empty: "Dodajte naslov, tekst ili medij prije objave.",
    title_required: "Unesite naslov prije objave.",
    success: "Objava je uspješno kreirana!",
    error: "Nešto je pošlo po zlu.",

    deal_id: "ID dogovora",
    deal_type: "Vrsta dogovora",
    status: "Status",
    price: "Cijena",
    currency: "Valuta",
    sport: "Sport",
    location: "Lokacija",
    event_date: "Datum događaja",
    received_amount: "Primljeni iznos",
    paid_at: "Plaćeno",
    no_closed_deal_payments: "Nema dostupnih plaćanja za zatvorene dogovore.",
    go_to_deals: "Idi na dogovore",
    active_deal: "Aktivni dogovor",
    closed_deal: "Zatvoreni dogovor",
    loading_active_deals: "Učitavanje aktivnih dogovora...",
    no_active_deals: "Nema dostupnih aktivnih dogovora.",
    created_at: "Kreirano",
    fighter: "Borac",
    manager: "Menadžer",
    refund: "Povrat",
    deal_types: {
      FIGHT_SINGLE: "Pojedinačna borba",
      FIGHT_TOURNAMENT: "Turnirska borba",
      SPARRING: "Sparing",
    },
    deal_status: {
      PROPOSED: "Predloženo",
      ACCEPTED: "Prihvaćeno",
      CONFIRMED: "Potvrđeno",
      WAITING_FOR_RESULT: "Čeka se rezultat",
      RESULT_UPDATED: "Rezultat ažuriran",
      RESULT_CONFIRMED: "Rezultat potvrđen",
      FIGHTER_RATED: "Borac ocijenjen",
      MANAGER_RATED: "Menadžer ocijenjen",
      FINISHED: "Završeno",
      CANCELLED: "Otkazano",
      REJECTED: "Odbijeno",
      DISPUTE: "Spor",
    },
    total_income: "Ukupni prihod",
    total_refund: "Ukupni povrat",
    total_expense: "Ukupni trošak",
    total_deals: "Ukupno dogovora",
    expense_amount: "Iznos troška",
    income: "Prihod",
    no_payments: "Nema dostupnih plaćanja za zatvorene dogovore."
  }
};
